import { round2 } from './math.js';
const LOCALE = { en: 'en-CA', fr: 'fr-CA' };
export function describeBudget(options, managedSensors, lang) {
    if (lang === 'fr') {
        const parts = [
            `${managedSensors} ${managedSensors === 1 ? 'capteur surveillé' : 'capteurs surveillés'}`,
            `${options.installation ? 'incluant' : 'sans'} l'installation par ATEK`,
        ];
        if (!options.configuration)
            parts.push('configuration par le client');
        if (options.calibration)
            parts.push('avec étalonnage');
        if (options.iqoq)
            parts.push('avec rapport de validation IQ/OQ');
        return parts.join(', ');
    }
    const parts = [
        `${managedSensors} monitored ${managedSensors === 1 ? 'sensor' : 'sensors'}`,
        `${options.installation ? 'including' : 'without'} installation by ATEK`,
    ];
    if (!options.configuration)
        parts.push('configured by the customer');
    if (options.calibration)
        parts.push('with calibration');
    if (options.iqoq)
        parts.push('with IQ/OQ validation report');
    return parts.join(', ');
}
/** Whole amounts without decimals ("$13,550"), otherwise two decimals. fr-CA uses non-breaking spaces. */
export function formatMoney(amount, currency, lang) {
    const whole = Number.isInteger(round2(amount));
    return new Intl.NumberFormat(LOCALE[lang], {
        style: 'currency', currency, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2,
    }).format(amount);
}
/** Formats a `YYYY-MM-DD` date-only value. Noon UTC keeps the same calendar day in America/Montreal. */
export function formatDate(ymd, lang) {
    return new Intl.DateTimeFormat(LOCALE[lang], { dateStyle: 'long', timeZone: 'America/Montreal' }).format(new Date(`${ymd}T12:00:00Z`));
}
//# sourceMappingURL=describe.js.map